<template>
  <div class="object-detail">
    <div class="object-buttons">
      <!-- <button @click="qwe()">qwe</button> -->
      <button class="btn" @click="hideFullInfo()">
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.5 1L1.20711 5.29289C0.816582 5.68342 0.816583 6.31658 1.20711 6.70711L5.5 11" stroke="black" stroke-opacity="0.65" stroke-width="1.5"/>
        </svg>
        Назад к списку
      </button>
      <div class="small-buttons">
        <button @click="isSelectItem = !isSelectItem">
          <img src="@img/list.svg" alt="" title="Скрыть/показать поля">
        </button>
        <button @click="copyLinkZu()">
          <img src="@img/copy.svg" alt="" title="Копировать ссылку на объект">
        </button>
        <!-- <button>
          <img src="@img/print.svg" alt="" title="Распечатать">
        </button> -->
        <button @click="emitEdit()" v-if="permisCreate">
          <img src="@img/edit.svg" alt="" title="Редактировать">
        </button>
        <button @click="emitFitBounds()">
          <img src="@img/map.svg" alt="" title="Показать на карте">
        </button>
        <div class="item-list" :class="{active: isSelectItem}">
          <vue-custom-scrollbar class="scroll-item-list">
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('regNum')" @click="pushHiddenItem('regNum')" type="checkbox" hidden checked>
                <span>Учетный номер</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('iconsRow')" @click="pushHiddenItem('iconsRow')" type="checkbox" hidden checked>
                <span>Краткая информация о ЗУ</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('areaBygeom')" @click="pushHiddenItem('areaBygeom')" type="checkbox" hidden checked>
                <span>Фактическая площадь</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('areaBydoc')" @click="pushHiddenItem('areaBydoc')" type="checkbox" hidden checked>
                <span>Площадь по документам</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('block')" @click="pushHiddenItem('block')" type="checkbox" hidden checked>
                <span>Номер кадастрового квартала</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('regNumSource')" @click="pushHiddenItem('regNumSource')" type="checkbox" hidden checked>
                <span>Кадастровый номер ЗУ из которого образован</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('cadCost')" @click="pushHiddenItem('cadCost')" type="checkbox" hidden checked>
                <span>Кадастровая стоимость</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('cadRegisterGeom')" @click="pushHiddenItem('cadRegisterGeom')" type="checkbox" hidden checked>
                <span>Признак, стоит ли ЗУ на КУ в координатах</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('isNoPurpose')" @click="pushHiddenItem('isNoPurpose')" type="checkbox" hidden checked>
                <span>Признак, нецелевого использование ЗУ (с описанием)</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('docNoPurpose')" @click="pushHiddenItem('docNoPurpose')" type="checkbox" hidden checked>
                <span>Материалы, подтверждающие нецелевое использование</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('typeZu')" @click="pushHiddenItem('typeZu')" type="checkbox" hidden checked>
                <span>Тип ЗУ</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('groupLand')" @click="pushHiddenItem('groupLand')" type="checkbox" hidden checked>
                <span>Группы земель</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('createDate')" @click="pushHiddenItem('createDate')" type="checkbox" hidden checked>
                <span>Дата внесения сведений о ЗУ в Систему</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('updateDate')" @click="pushHiddenItem('updateDate')" type="checkbox" hidden checked>
                <span>Дата обновления сведений о ЗУ в Системе</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('permittedUse')" @click="pushHiddenItem('permittedUse')" type="checkbox" hidden checked>
                <span>Разрешенное использование</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('factUse')" @click="pushHiddenItem('factUse')" type="checkbox" hidden checked>
                <span>Фактическое использование</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('category')" @click="pushHiddenItem('category')" type="checkbox" hidden checked>
                <span>Категория земель</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('landTluSet')" @click="pushHiddenItem('landTluSet')" type="checkbox" hidden checked>
                <span>Тип угодий</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('kolhoz')" @click="pushHiddenItem('kolhoz')" type="checkbox" hidden checked>
                <span>Наименование колхоза</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('location')" @click="pushHiddenItem('location')" type="checkbox" hidden checked>
                <span>Адрес земельного участка</span>
              </label>
            </div>
            <div class="filter-check input-wrap">
              <label>
                <input :value="checkHiddenItem('rightSet')" @click="pushHiddenItem('rightSet')" type="checkbox" hidden checked>
                <span>Право</span>
              </label>
            </div>
          </vue-custom-scrollbar>
        </div>
      </div>
    </div>
    <vue-custom-scrollbar v-if="!loadingLandDetail" class="scroll-detail">
      <div class="object-detail-info" v-if="land !== undefined && land !== null">
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('regNum')" v-if="land.regNum !== null && land.regNum !== undefined">
            <h5>Учетный номер</h5>
            <p>{{ land.regNum }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item icons-item" v-show="!checkHiddenItem('iconsRow')">
            <div v-if="land.cadRegister !== null && land.cadRegister !== undefined" v-tooltip="{content: `${land.cadRegister ? 'ЗУ стоит на КУ' : 'ЗУ не стоит на КУ'}`}">
              <simple-svg
                :src="require('@/assets/images/certificate.svg')"
                :custom-class-name="land.cadRegister === true ? 'active-svg': ''"
              />
            </div>
            <div v-if="land.isOks !== null && land.isOks !== undefined" v-tooltip="{content: `${land.isOks ? 'Есть ОКС на ЗУ' : 'Нет ОКС на ЗУ'}`}">
              <simple-svg
                :src="require('@/assets/images/building.svg')"
                :custom-class-name="land.isOks ? 'active-svg': ''"
              />
            </div>
            <div v-if="land.isUse !== null && land.isUse !== undefined" v-tooltip="{content: `${land.isUse ? 'ЗУ используется' : 'ЗУ не используется'}`}">
              <simple-svg
              :src="require('@/assets/images/agricultural.svg')"
              :custom-class-name="land.isUse ? 'active-svg': ''"
            />
            </div>
            <div v-if="land.nameSystemCoord !== null && land.nameSystemCoord !== undefined" v-tooltip="{content: land.nameSystemCoord}">
              <simple-svg
              :src="require('@/assets/images/sc.svg')"
              :custom-class-name="land.nameSystemCoord ? 'active-svg': ''"
            />
            </div>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('areaBygeom')" v-if="land.areaBygeom !== null && land.areaBygeom !== undefined">
            <h5>Фактическая площадь</h5>
            <p>{{ land.areaBygeom.toLocaleString('ru-RU') }} м<sup>2</sup></p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('areaBydoc')" v-if="land.areaBydoc !== null && land.areaBydoc !== undefined">
            <h5>Площадь по документам</h5>
            <p>{{ land.areaBydoc.toLocaleString('ru-RU') }} м<sup>2</sup></p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('areaBydoc')" v-if="land.contourSet !== null && land.contourSet !== undefined && land.contourSet.edges.length > 1">
            <h5>Элементы земельного участка</h5>
            <p
              v-for="(contourRegNum, index) in land.contourSet.edges"
              :key="index"
              @click="showContourOnMap(index)"
              class="countour-point"
            >{{ contourRegNum.node.properties.regNum }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('block')" v-if="land.block !== null && land.block !== undefined">
            <h5>Номер кадастрового квартала</h5>
            <p>{{ land.block }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('regNumSource')" v-if="land.regNumSource !== null && land.regNumSource !== undefined">
            <h5>Кадастровый номер ЗУ из которого образован</h5>
            <p>{{ land.regNumSource }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('cadCost')" v-if="land.cadCost !== null && land.cadCost !== undefined">
            <h5>Кадастровая стоимость</h5>
            <p>{{ land.cadCost.toLocaleString('ru-RU') }} ₽</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('cadRegisterGeom')" v-if="land.cadRegisterGeom !== null && land.cadRegisterGeom !== undefined">
            <h5>Признак, стоит ли ЗУ на КУ в координатах (да/нет)</h5>
            <p>{{ land.cadRegisterGeom ? 'Да' : 'Нет' }}</p>
          </div>
        </transition>
        <!-- <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('isUse')" v-if="land.isUse !== null && land.isUse !== undefined">
            <h5>Признак, что ЗУ не используется (да/нет)</h5>
            <p>{{ land.isUse ? 'Да' : 'Нет' }}</p>
          </div>
        </transition> -->
        <!-- <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('isOks')" v-if="land.isOks !== null && land.isOks !== undefined">
            <h5>Признак, наличие ОКС на ЗУ (да/нет)</h5>
            <p>{{ land.isOks ? 'Да' : 'Нет' }}</p>
          </div>
        </transition> -->
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('isNoPurpose')" v-if="land.isNoPurpose !== null && land.isNoPurpose !== undefined">
            <h5>Признак, нецелевого использование ЗУ (с описанием) (да/нет)</h5>
            <p>{{ land.isNoPurpose ? 'Да' : 'Нет' }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('docNoPurpose')" v-if="land.docNoPurpose !== null && land.docNoPurpose !== undefined">
            <h5>Материалы, подтверждающие нецелевое использование</h5>
            <p>{{ land.docNoPurpose }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('typeZu')" v-if="land.typeZu !== null && land.typeZu !== undefined">
            <h5>Тип ЗУ</h5>
            <p>{{ land.typeZu.text }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('groupLand')" v-if="land.groupLand !== null && land.groupLand !== undefined">
            <h5>Группы земель</h5>
            <p>{{ land.groupLand }}</p>
          </div>
        </transition>
        <!-- <div class="object-detail-item" v-if="land.isCheck !== null && land.isCheck !== undefined">
          <h5>Признак, пройдена ли проверка на корректность (да/нет)</h5>
          <p>{{ land.isCheck ? 'Да' : 'Нет' }}</p>
        </div>
        <div class="object-detail-item" v-if="land.isArchive !== null && land.isArchive !== undefined">
          <h5>Признак, является ли данный ЗУ архивным</h5>
          <p>{{ land.isArchive ? 'Да' : 'Нет' }}</p>
        </div>
        <div class="object-detail-item" v-if="land.isActual !== null && land.isActual !== undefined">
          <h5>Признак, является ли данный ЗУ актуальным</h5>
          <p>{{ land.isActual ? 'Да' : 'Нет' }}</p>
        </div> -->
        <!-- <div class="object-detail-item" v-if="land.actualDate !== null && land.actualDate !== undefined">
          <h5>Дата актуальности</h5>
          <p>{{ land.actualDate }}</p>
        </div> -->
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('createDate')" v-if="land.createDate !== null && land.createDate !== undefined">
            <h5>Дата внесения сведений о ЗУ в Систему</h5>
            <p>{{ land.createDate }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('updateDate')" v-if="land.updateDate !== null && land.updateDate !== undefined">
            <h5>Дата обновления сведений о ЗУ в Системе</h5>
            <p>{{ land.updateDate }}</p>
          </div>
        </transition>
        <!-- <div class="object-detail-item" v-if="land.note !== null && land.note !== undefined">
          <h5>Примечание</h5>
          <p>{{ land.note }}</p>
        </div> -->
        <transition name="item-toggle">
          <template v-if="land.permittedUse !== null && land.permittedUse !== undefined">
            <div class="object-detail-item" v-show="!checkHiddenItem('permittedUse')" v-if="land.permittedUse.landUseBydoc !== null && land.permittedUse.landUseBydoc !== undefined">
              <h5>Разрешенное использование</h5>
              <p>{{ land.permittedUse.landUseBydoc }}</p>
            </div>
          </template>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('factUse')" v-if="land.factUse !== null && land.factUse !== undefined">
            <h5>Фактическое использование</h5>
            <p>{{ land.factUse }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('category')" v-if="land.category !== null && land.category !== undefined">
            <h5>Категория земель</h5>
            <p>{{ land.category.text }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('landTluSet')" v-if="land.landTluSet !== null && land.landTluSet !== undefined && land.landTluSet.edges.length > 0">
            <h5>Тип угодий</h5>
            <p v-for="(edge, index) in land.landTluSet.edges" :key="index">{{ edge.node.tlu.text + ' - ' + edge.node.area.toLocaleString('ru-RU') }} м<sup>2</sup></p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('kolhoz')" v-if="land.location !== undefined && land.location !== null && (land.location.kolhoz !== null && land.location.kolhoz !== undefined)">
            <h5>Наименование колхоза</h5>
            <p>{{ land.location.kolhoz }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('location')" v-if="land.location !== undefined && land.location !== null && (land.location.text !== null && land.location.text !== undefined)">
            <h5>Адрес земельного участка</h5>
            <p>{{ land.location.text }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div class="object-detail-item" v-show="!checkHiddenItem('location')" v-if="land.location !== undefined && land.location !== null && (land.location.note !== null && land.location.note !== undefined)">
            <h5>Описание</h5>
            <p>{{ land.location.note }}</p>
          </div>
        </transition>
        <transition name="item-toggle">
          <div v-show="!checkHiddenItem('rightSet')" v-if="land.rightSet !== null && land.rightSet !== undefined">
            <RightVue v-for="(item, index) in land.rightSet.edges" :key="index" :item="item.node" :rightIndex="index" :pk="pk"></RightVue>
          </div>
        </transition>
        <div class="object-detail-item gallery-wrap" v-if="land.photoSet !== undefined && land.photoSet !== null && land.photoSet.edges.length > 0 && !rebootSlider">
          <h5>Фото объекта</h5>
          <tiny-slider
            v-bind="tinySliderOptions"
          >
            <div class="img-wrap" @click="showGallery = true" v-for="(imgEdge, imgIndex) in land.photoSet.edges" :key="imgIndex">
              <div
                class="gallery-preview"
                :style="`background-image: url(${getImageUrl(imgEdge.node.file)})`">
              </div>
            </div>
          </tiny-slider>
        </div>
        <div class="object-detail-item gallery-wrap" v-if="land.appendixSet !== undefined && land.appendixSet !== null && land.appendixSet.edges !== undefined && land.appendixSet.edges.length > 0">
          <h5>Приложения</h5>
          <tiny-slider
            v-bind="tinySliderOptions"
          >
            <div class="doc-item" v-for="(appendEdge, appendIndex) in land.appendixSet.edges" :key="appendIndex">
              <a :href="getAppendixUrl(appendEdge.node.file)">
                <button>
                  <img src="@img/download.svg" alt="">
                </button>
                <div class="doc-info">
                  <span class="doc-title">{{ appendEdge.node.name }}</span>
                  <!-- <span class="doc-format">appendEdge.node.name</span> -->
                </div>
              </a>
            </div>
          </tiny-slider>
        </div>
      </div>
    </vue-custom-scrollbar>
    <transition name="fadeIn">
      <EncumbranceVue
        v-if="encumbranceDetail[encIndex] === 'true'"
        :pk="pk"
        :encObj="land.rightSet.edges[rightIndex].node.encumbranceSet.edges[encIndex].node"
      ></EncumbranceVue>
    </transition>
    <div v-if="loadingLandDetail" class="preloader pr-3">
      <svg class="loader lr-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340">
        <circle cx="170" cy="170" r="160" stroke="#4E53E7"/>
        <circle cx="170" cy="170" r="135" stroke="#404041"/>
        <circle cx="170" cy="170" r="110" stroke="#4E53E7"/>
        <circle cx="170" cy="170" r="85" stroke="#404041"/>
      </svg>
    </div>
    <transition name="popup-opacity">
      <PopupVue @closePopup="closePopup" v-if="showGallery">
        <template #content>
          <GalleryPopupVue :photoSet="land.photoSet.edges"></GalleryPopupVue>
        </template>
      </PopupVue>
    </transition>
  </div>
</template>

<script>
import EncumbranceVue from './EncumbranceVue'
import RightVue from './RightVue.vue'
import PopupVue from '@/components/PopupVue.vue'
import GalleryPopupVue from '@/components/popup/GalleryPopupVue.vue'
import Swiper, { Navigation, Pagination } from 'swiper'
import { eventBus } from '@/main.js'
// eslint-disable-next-line
import swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

Swiper.use([Navigation, Pagination])

export default {
  name: 'ObjectDetailVue',
  props: ['pk', 'isFull'],
  components: {
    RightVue,
    PopupVue,
    GalleryPopupVue,
    EncumbranceVue
  },
  data () {
    return {
      showRight: [],
      hiddenDetailItem: [],
      isSelectItem: false,
      showGallery: false,
      rebootSlider: false,
      rightDetail: null,
      tinySliderOptions: {
        mouseDrag: true,
        loop: false,
        nav: false,
        gutter: 8,
        items: 1,
        fixedWidth: '160px',
        controlsText: ['', '']
      }
    }
  },
  watch: {
    id () {
      this.$store.dispatch('SET_VALUE', {key: 'encumbranceDetail', value: false})
    },
    land () {
      this.rebootSlider = true
      setTimeout(() => {
        this.rebootSlider = false
      }, 10)
    }
  },
  computed: {
    isFullInfo () {
      return this.$store.getters.value('isFullInfo')
    },
    land () {
      return this.$store.getters.value('land')
    },
    loadingLandDetail () {
      return this.$store.getters.value('loadingLandDetail')
    },
    encumbranceDetail () {
      return this.$store.getters.value('encumbranceDetail')
    },
    rightIndex () {
      return this.$store.getters.value('rightIndex')
    },
    encIndex () {
      return this.$store.getters.value('encIndex')
    },
    permisCreate () {
      return this.checkHavePermissionMix('change_', '*')
    }
  },
  methods: {
    closePopup (val) {
      this.showGallery = false
    },
    pushHiddenItem (title) {
      let index = this.hiddenDetailItem.indexOf(title)
      if (index === -1) {
        this.hiddenDetailItem.push(title)
      } else {
        this.hiddenDetailItem.splice(index, 1)
      }
    },
    checkHiddenItem (title) {
      return this.hiddenDetailItem.indexOf(title) !== -1
    },
    getAppendixUrl (key) {
      if (key === null && key === undefined) {
        return 'javascript:void(0)'
      }
      return this.getMinioFileUrlMix('appendix', key)
    },

    getImageUrl (key) {
      if (key === null && key === undefined) {
        return 'javascript:void(0)'
      }
      return this.getMinioFileUrlMix('photo', 'preview_' + key)
    },
    emitFitBounds () {
      let pk = this.land.pk
      if (pk !== undefined) {
        this.$emit('emitFitBoundsFromDetail', pk)
      }
    },

    showContourOnMap (index) {
      let featureData = {
        pk: this.land.pk,
        index: index
      }
      // console.log()
      // let pk = this.land.pk
      if (featureData.pk !== undefined) {
        eventBus.$emit('boundFeature', {pk: featureData.pk, index: featureData.index})
      }
    },

    emitEdit () {
      let pk = this.land.pk
      if (pk !== undefined) {
        this.$emit('editFromDetail', pk)
      }
    },
    hideFullInfo () {
      this.$store.dispatch('SET_VALUE', {key: 'isFullInfo', value: false})
      this.$store.dispatch('SET_VALUE', {key: 'encumbranceDetail', value: []})
      this.isSelectItem = false
    },
    addClassButton () {
      let prevButton = document.querySelectorAll('.tns-controls button')[0]
      prevButton.classList.add('slider-prev')
      let nextButton = document.querySelectorAll('.tns-controls button')[1]
      nextButton.classList.add('slider-next')
    },

    copyLinkZu () {
      navigator.clipboard.writeText(this.$store.getters.value('host') + ((process.env.VUE_APP_ROUTER_MODE !== undefined && process.env.VUE_APP_ROUTER_MODE !== 'history') ? '/#' : '') + '/' + this.land.pk)
        .then(() => {
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Копирование',
            text: 'Ссылка на объект успешно скопирована!'
          })
        })
        .catch(err => {
          console.warn(err)
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Копирование',
            text: 'Произошла ошибка при копировании ссылки на объект!'
          })
        })
    },
    qwe () {
      console.log(this.land)
    }
  }
}
</script>

<style lang="scss">
@import '~tiny-slider/src/tiny-slider';

.active-svg {
  fill: #4E53E7
}

.item-toggle-enter-active {
  transition: all .3s ease;
}
.item-toggle-leave-active {
  transition: all .3s;
}
.item-toggle-enter, .item-toggle-leave-to {
  transform: translateX(-200px);
  opacity: 0;
}

.fadeIn-enter-active {
  transition: all 1.2s;
}
.fadeIn-enter {
  opacity: 0;
}

.slider-prev {
  background-color: red;
}

.item-list {
  position: absolute;
  background-color: #fff;
  top: -200px;
  right: 5px;
  width: 300px;
  max-height: 570px;
  height: 80%;
  border-radius: 8px;
  opacity: 0;
  visibility: hidden;
  padding: 10px;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2);
  transition: .3s;
  z-index: 1;
  .scroll-item-list {
    padding-right: 15px;
    height: 100%;
  }
  &.active {
    top: 65px;
    opacity: 1;
    visibility: visible;
  }
  .filter-check {
    position: relative;
    margin-bottom: 5px;
  }
}
.object-detail {
  // user-select: none; // fix swap slider
  position: absolute;
  left: 30px;
  padding-top: 30px;
  padding-right: 30px;
  width: calc(100% - 30px);
  height: 100%;
  @media screen and (max-width: 768px){
    left: 0;
    right: 0;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
  }
  .btn {
    border: 1px solid #e6e6e6;
    transition: .3s;
    &:hover {
      border-color: #4e53e7;
    }
  }
  .object-buttons {
    max-width: 360px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .small-buttons {
    @media screen and (max-width: 768px){
      display: none;
    }
    button {
      margin-left: 20px;
    }
  }
  &-info {
    position: relative;
    max-width: 410px;
  }
  /* .right-wrap,
  .owner-wrap {
    padding-top: 25px;
  } */

  &-item {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e6e6e6;
    margin-right: 30px;
    .countour-point {
      cursor: pointer;
      margin-bottom: 10px;
      transition: .3s;
      &:last-child {
        margin-bottom: 0;
      }
      &:hover {
        color: #4E53E7
      }
    }
    .gallery-preview {
      width: 160px;
      height: 90px;
      border-radius: 4px;
      cursor: pointer;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      background-size: cover;
    }
    &.icons-item {
      display: flex;
      & > div {
        margin-right: 15px;
      }
    }
    &:last-child {
      // padding-bottom: 0;
      margin-bottom: 0;
      // border: none;
    }
    h5 {
      margin-bottom: 10px;
      font-size: 14px;
    }
    p {
      margin-bottom: 0;
    }
    &.gallery-wrap {
      margin-top: 25px;
      margin-right: 0;
      user-select: none;
    }
  }
  .scroll-detail {
    position: absolute;
    overflow: auto;
    display: flex;
    flex-direction: column;
    max-width: 390px;
    width: 100%;
    height: calc(100% - 140px);
    @media screen and (max-width: 768px){
      height: calc(100% - 120px);
    }
  }
  .doc-item {
    cursor: pointer;
    padding: 15px 10px;
    text-align: center;
    margin-right: 10px;
    max-width: 160px;
    height: 95px;
    border-radius: 2px;
    margin-top: 15px;
    border: 1px solid #e6e6e6;
    transition: .3s;
    &:hover {
      border-color: #4e53e7;
    }
    span {
      display: block;
    }
    .button {
      margin-bottom: 10px;
    }
    .doc-info {
      flex: none;
      max-width: 305px;
      width: 100%;
      font-size: 12px;
    }
    .doc-title {
      margin-top: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .doc-format {
      margin-top: 5px;
      font-size: 12px;
      color: #a6a6a6;
    }
  }
}

.right-wrap {
  .object-detail-item {
    &:last-child {
      border-bottom: none;
      border-bottom: 1px solid #e6e6e6;
      // padding-bottom: 0;
    }
  }
}

.loading {
  left: -50px;
  width: calc(100% + 50px);
  top: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/ObjectDetailVue.vue